import { useEffect, useState } from "react";
import styles from "./article-home.module.css";
import {
  getArticleFileToDownload,
  getArticles,
  getITNews,
  getNewsFileToDownload,
} from "../../services/news/news.service";

export default function ArticleHome() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [articles, setArticles] = useState([]);
  const [itNews, setITNews] = useState([]);
  let [loadingArticle, setLoadingArticle] = useState([]);
  useEffect(() => {
    getArticles().then(({ data }) => {
      setArticles((data && data.data) || []);
    });
    getITNews().then(({ data }) => {
      const tempNews = data && data.data;
      setITNews(tempNews);
    });
  }, []);
  const downloadITNews = (item) => {
    let tmpLoading = [...loadingArticle];
    tmpLoading[item.id] = true;
    setLoadingArticle(tmpLoading);
    getNewsFileToDownload(item.id)
      .then((data) => {
        const downloadLink = document.createElement("a");
        const fileName = `${item.title} ${item.publish_date}.pdf`;
        downloadLink.href = data.data;
        downloadLink.download = fileName;
        downloadLink.click();
        downloadLink.remove();
        tmpLoading = [...loadingArticle];
        for (let el of tmpLoading) {
          el = false;
        }
        setTimeout(function () {
          setLoadingArticle(tmpLoading);
        }, 1000);
      })
      .catch((e) => {
        tmpLoading = [...loadingArticle];
        for (let el of tmpLoading) {
          el = false;
        }
        setTimeout(function () {
          setLoadingArticle(tmpLoading);
        }, 1000);
      });
  };

  const downloadArticle = (item) => {
    let tmpLoading = [...loadingArticle];
    tmpLoading[item.id] = true;
    setLoadingArticle(tmpLoading);
    getArticleFileToDownload(item.id)
      .then((data) => {
        const downloadLink = document.createElement("a");
        const fileName = `${item.title} ${item.publish_date}.pdf`;
        downloadLink.href = data.data;
        downloadLink.download = fileName;
        downloadLink.click();
        downloadLink.remove();
        tmpLoading = [...loadingArticle];
        for (let el of tmpLoading) {
          el = false;
        }
        setTimeout(function () {
          setLoadingArticle(tmpLoading);
        }, 1000);
      })
      .catch((e) => {
        tmpLoading = [...loadingArticle];
        for (let el of tmpLoading) {
          el = false;
        }
        setTimeout(function () {
          setLoadingArticle(tmpLoading);
        }, 1000);
      });
  };
  const handleDownload = (item) => {
    if (activeIndex === 0) {
      downloadITNews(item);
    } else {
      downloadArticle(item);
    }
  };
  return Array.isArray(itNews) &&
    Array.isArray(articles) &&
    articles.length > 0 &&
    itNews.length > 0 ? (
    <div className="container">
      <div className={styles.tabsContainer}>
        <div className={styles.tabsWrapper}>
          <div
            className={
              activeIndex === 0
                ? `${styles.activeTab} ${styles.rightTab}`
                : `${styles.activeTab} ${styles.leftTab}`
            }
          />
          <div
            onClick={() => setActiveIndex(0)}
            className={activeIndex === 0 ? styles.activeItem : null}
          >
            <i className="fa fa-rss" /> اخبار فناوری اطلاعات
          </div>
          <div
            onClick={() => setActiveIndex(1)}
            className={activeIndex === 1 ? styles.activeItem : null}
          >
            <i className="fa fa-file" /> مقالات
          </div>
        </div>
      </div>
      <div className={styles.articlesWrapper}>
        <div className={styles.articleTableContent}>
          {(Array.isArray(itNews) && itNews.length > 0) ||
          (Array.isArray(articles) && articles.length > 0) ? (
            <table>
              <thead>
                <tr>
                  <th className={`${styles.firstCol} hidden-xs`}>
                    <span className="hidden-xs">
                      <span className={styles.sortable}>
                        <i className="fa fa-angle-up" />
                        <i className="fa fa-angle-down" />
                      </span>
                      ردیف
                    </span>
                    <span className="visible-xs">#</span>
                  </th>
                  <th className={styles.mobileTitleTable}>
                    <span>عنوان</span>
                  </th>
                  <th className="hidden-xs">
                    <span>تاریخ انتشار</span>
                  </th>
                  <th className={styles.lastCol}>
                    <span>عملیات</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {(activeIndex === 0 ? itNews : articles).map((item, index) => (
                  <tr key={`it-news-${index}`}>
                    <td className={`${styles.firstCol} hidden-xs`}>
                      {index + 1}
                    </td>
                    <td className={styles.mobileTitleTable}>{item.title}</td>
                    <td className="hidden-xs">{item.publish_date}</td>
                    <td className={styles.lastCol}>
                      <button
                        disabled={loadingArticle[item.id]}
                        className={styles.actionButton}
                        onClick={() => handleDownload(item)}
                      >
                        {!loadingArticle[item.id] ? (
                          <i className={"fa fa-download"} />
                        ) : (
                          <img
                            className={styles.loadingImage}
                            src={"/assets/image/loading.svg"}
                            alt={item.title}
                          />
                        )}
                        <span className="hidden-xs">دانلود</span>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="loading-wrapper">
              <img src={"/assets/image/loading.svg"} alt={"در حال بار گذاری"} />
            </div>
          )}
        </div>
        <div className={styles.arrowCarets}>
          <div>
            <i className="fa fa-angle-right" />
          </div>
          <div>
            <i className="fa fa-angle-left" />
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
}
